import { createFileRoute, notFound } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

// The heavy Lab (leva + the full control panel) is lazy-loaded so it lands in
// its own chunk and never bloats the shipped bundle.
const StageLab = lazy(() => import("@/features/viewer/components/StageLab"));

// DEV-ONLY debugging route (issue #79): a live tuning bench for the 3D Stage.
// Guarded on Vite's import.meta.env.DEV — in a production build the guard throws
// notFound() before the component loads, so the route is unreachable (and the
// lab chunk is never fetched) in prod.
export const Route = createFileRoute("/stage-lab")({
  beforeLoad: () => {
    if (!import.meta.env.DEV) throw notFound();
  },
  component: () => (
    <Suspense fallback={null}>
      <StageLab />
    </Suspense>
  ),
});
